import { render } from "./NotificationsList.vue?vue&type=template&id=68f5cf1d&lang=pug"
import script from "./NotificationsList.vue?vue&type=script&lang=js"
export * from "./NotificationsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__